import { MineSweeper } from "../Games/Mines/MineSweeper";

export default function MinesPage() {
  return (
    <MineSweeper />
  );
}
